// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__l1jZy","Open":"SideDrawer_Open__3_GVO","Close":"SideDrawer_Close__d3VM5","Logo":"SideDrawer_Logo__plNQa"};